export function previewArticleSale(cost:number|null,coefficient:number|null,quantity:number|null) {
 const validCost=cost!==null && Number.isFinite(cost) && cost>=0;
 const validCoefficient=coefficient!==null && Number.isFinite(coefficient) && coefficient>0;
 const validQuantity=quantity!==null && Number.isFinite(quantity) && quantity>=0;
 const round=(v:number,places:number)=>Math.round((v+Number.EPSILON)*10**places)/10**places;
 const rawSale=validCost && validCoefficient ? cost!*coefficient! : null;
 return {
  saleUnit:rawSale!==null && Number.isFinite(rawSale) ? round(rawSale,4) : null,
  dryTotal:validCost && validQuantity ? round(cost!*quantity!,2) : null,
  saleTotal:rawSale!==null && validQuantity && Number.isFinite(rawSale*quantity!) ? round(rawSale*quantity!,2) : null,
 };
}
export function pricingNumber(value:unknown):number|null {
 if(value===null || value===undefined || typeof value==="boolean"
  || (typeof value==="string" && !value.trim()) || !["number","string"].includes(typeof value))return null;
 const n=Number(value);return Number.isFinite(n) ? n : null;
}
